/**
 * @file Professional location service — CRUD for a professional's practice
 *       locations (physical offices and virtual/teleconsulta).
 *
 * All endpoints are scoped to the authenticated professional via `/professional/me`.
 *
 * @module services/professionalLocation
 */
import api from "./api";

/**
 * Location CRUD methods.
 * @type {Object}
 */
export const professionalLocationService = {
  /** @returns {Promise<Object[]>} All locations for the current professional. */
  getAll: () => api.get("/professional/me/locations"),
  /** @param {{ name?: string, address?: string, colonia?: string, city?: string, state?: string, isVirtual?: boolean }} data */
  create: (data) => api.post("/professional/me/locations", data),
  /** @param {string} id  @param {Object} data - Partial location fields to update. */
  update: (id, data) => api.put(`/professional/me/locations/${id}`, data),
  /** @param {string} id */
  remove: (id) => api.delete(`/professional/me/locations/${id}`),
};
